/**
* Function for instantiating and dispatching a JavaScript CustomEvent for
* signaling that an overlay has loaded within a given page.
*
* @param {String} overlay - String representing the name of the overlay
* being loaded within the given page.
*/
function dispatchOverlayLoad(overlay) {
	try {
		// instantiate a CustomEvent with an eventType of “overlayLoad”
		// eslint-disable-next-line
		const event = new CustomEvent("overlayLoad", {
			detail: {
				// set the value of the function’s overlay parameter to
                // an “overlay” property on the CustomEvent’s detail object
				overlay
			}
		});
		// dispatch the CustomEvent from the body
		document.body.dispatchEvent(event);
	} catch(e) {
		// handle exceptions as needed
	}
}

export default dispatchOverlayLoad;
